import * as React from "react";
import { Disclosure } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { Link } from "gatsby";
// import { CloudDownloadIcon, ChatAltIcon } from "@heroicons/react/outline";
import { StaticImage } from "gatsby-plugin-image";

const navigation = [
  { name: "How It Works", href: "/how-it-works", current: false },
  { name: "Cost Of Outages", href: "/cost-of-outages", current: false },
  // { name: "About", href: "/about", current: false },
  { name: "News", href: "/blog-list", current: false },
  {
    name: "ServiceNow App",
    href: "https://store.servicenow.com/sn_appstore_store.do#!/store/application/2f1cbfe6db4e2810d2f8378239961940/",
    current: false,
  },
  { name: "Vendor Integrations", href: "/vendors", current: false },
  { name: "ODD", href: "https://odd.findbugzero.com", current: false },
  // { name: "Operational Defect Database", href: "https://odd.findbugzero.com/", current: false },
  { name: "Contact", href: "/contact", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const toggleTheme = (e) => {
  let themeToggleDarkIcon = document.getElementById("theme-toggle-dark-icon");
  let themeToggleLightIcon = document.getElementById("theme-toggle-light-icon");

  themeToggleDarkIcon.classList.toggle("hidden");
  themeToggleLightIcon.classList.toggle("hidden");

  // if set via local storage previously
  if (localStorage.getItem("color-theme")) {
    if (localStorage.getItem("color-theme") === "light") {
      document.documentElement.classList.add("dark");
      localStorage.setItem("color-theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("color-theme", "light");
    }
  }
};

export default function Navigation() {
  return (
    <Disclosure as="nav" className="sticky top-0 z-40 bg-branding-blue py-2">
      {({ open }) => (
        <>
          <div className="shadow-y1 mx-auto px-2 sm:px-6 xl:px-8">
            <div className="relative flex items-center justify-between h-12">
              <div className="absolute inset-y-0 left-0 flex items-center xl:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center px-2 pt-1 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center xl:items-stretch xl:justify-start">
                <Link
                  id="BugZero-logo"
                  to="/"
                  className="flex-shrink-0 ml-4 sm:ml-0"
                >
                  <StaticImage
                    alt="BugZero Logo and link to home page"
                    id="BugZero-logo-link-to-home-page"
                    className="h-7 w-24 mt-1 ml-10 xl:ml-0"
                    src="../images/logo.png"
                    placeholder="blurred"
                  />
                </Link>
                <div className="hidden xl:block xl:ml-6">
                  <div className="flex space-x-4">
                    {navigation.map((item) =>
                      item.name === "ServiceNow App" || item.name === "ODD" ? (
                        <a
                          key={item.name}
                          href={item.href}
                          name={item.name}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={classNames(
                            item.current
                              ? "text-white"
                              : "text-gray-100 hover:text-white",
                            "px-3 py-2 rounded-md text-sm font-normal"
                          )}
                          aria-current={item.current ? "page" : undefined}
                        >
                          {item.name}
                        </a>
                      ) : (
                        <Link
                          key={item.name}
                          to={item.href}
                          name={item.name}
                          className={classNames(
                            item.current
                              ? "text-white"
                              : "text-gray-100 hover:text-white",
                            "px-3 py-2 rounded-md text-sm font-normal"
                          )}
                          aria-current={item.current ? "page" : undefined}
                        >
                          {item.name}
                        </Link>
                      )
                    )}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 inline-flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <div className="inline-flex space-x-8 sm:justify-center sm:mt-0">
                  <button
                    id="theme-toggle"
                    aria-label="toggle theme for website"
                    type="button"
                    onClick={toggleTheme}
                  >
                    <svg
                      id="theme-toggle-dark-icon"
                      className="hidden w-5 h-5 text-gray-100 hover:text-gray-100"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
                    </svg>
                    <svg
                      id="theme-toggle-light-icon"
                      className="hidden w-5 h-5 text-gray-100 hover:text-gray-100"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </button>

                  {/* <a
                    href="https://twitter.com/findbugzero"
                    className="mt-1 text-gray-100 hover:text-gray-100 hidden sm:inline-flex"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="link to twitter company page"
                    id="twitter-link"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                    </svg>
                  </a> */}
                  <a
                    href="https://www.linkedin.com/company/findbugzero"
                    className="mt-2 text-gray-100 hover:text-gray-100 hidden sm:inline-flex"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="link to linkedin company page"
                    id="linkedin-link"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M13.0214 0H1.02084C0.453707 0 0 0.451613 0 1.01613V12.9839C0 13.5258 0.453707 14 1.02084 14H12.976C13.5432 14 13.9969 13.5484 13.9969 12.9839V0.993548C14.0422 0.451613 13.5885 0 13.0214 0ZM4.15142 11.9H2.08705V5.23871H4.15142V11.9ZM3.10789 4.3129C2.42733 4.3129 1.90557 3.77097 1.90557 3.11613C1.90557 2.46129 2.45002 1.91935 3.10789 1.91935C3.76577 1.91935 4.31022 2.46129 4.31022 3.11613C4.31022 3.77097 3.81114 4.3129 3.10789 4.3129ZM11.9779 11.9H9.9135V8.67097C9.9135 7.90323 9.89082 6.8871 8.82461 6.8871C7.73571 6.8871 7.57691 7.74516 7.57691 8.60323V11.9H5.51254V5.23871H7.53154V6.16452H7.55423C7.84914 5.62258 8.50701 5.08065 9.52785 5.08065C11.6376 5.08065 12.0232 6.43548 12.0232 8.2871V11.9H11.9779Z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                  {/* <Link
                    to="/#contact"
                    id="contact-link"
                    aria-label="contact us link"
                    className="mt-2 text-gray-100 hover:text-gray-100"
                  >
                    <ChatAltIcon className="h-5 w-5" aria-hidden="true" />
                  </Link> */}
                  {/* <a
                    href="https://store.servicenow.com/sn_appstore_store.do#!/store/application/2f1cbfe6db4e2810d2f8378239961940/1.1.5?referer=%2Fstore%2Fsearch%3Flistingtype%3Dallintegrations%25253Bancillary_app%25253Bcertified_apps%25253Bcontent%25253Bindustry_solution%25253Boem%25253Butility%25253Btemplate%26q%3Dbugzero&sl=sh"
                    className="mt-2 text-gray-100 hover:text-gray-100 hidden sm:block"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="snstore-link"
                    aria-label="service now store link"
                  >
                    <CloudDownloadIcon className="h-5 w-5" aria-hidden="true" />
                  </a> */}
                  <Link
                    to="/calendly"
                    id="calendly-link"
                    className="px-3 py-1 inline-flex align-items-center py-auto rounded-md text-sm font-bold bg-branding-red hover:branding-red-light text-gray-100 hover:text-white"
                  >
                    Schedule a call
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="xl:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  id={item.name + "-id"}
                  name={item.name + "-name"}
                  className={classNames(
                    item.current
                      ? "bg-gray-900 text-white"
                      : "text-gray-100 hover:bg-gray-700 hover:text-white",
                    "block px-3 py-2 rounded-md text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
